<template>
	<!-- Prezzo/valuta, quantita' e spedizione modificabili di un'inserzione Amazon:
	     condivisi tra la tabella (desktop) e la card (telefono) di views/amazon/Index.vue -->
	<div class="seller-fields">
		<div class="d-flex">
			<v-text-field v-model="item.sellerPrice" label="Prezzo" type="number" dense outlined hide-details @change="$emit('price', item)" @click="$emit('price', item)">
				<template slot="append-outer" v-if="operazione('price')">
					<v-icon color="primary" @click="$emit('save', item.operation)">mdi-content-save-outline</v-icon>
				</template>
			</v-text-field>
			<v-select
				class="ml-2 currency-select"
				:items="currencies"
				v-model="item.sellerCurrency"
				label="Valuta"
				item-text="id"
				item-value="id"
				dense
				outlined
				hide-details
				@change="$emit('price', item)"
			></v-select>
		</div>
		<v-text-field v-model="item.sellerQt" label="Quantità" type="number" dense outlined hide-details @change="$emit('quantity', item)" @click="$emit('quantity', item)">
			<template slot="append-outer" v-if="operazione('quantity')">
				<v-icon color="primary" @click="$emit('save', item.operation)">mdi-content-save-outline</v-icon>
			</template>
		</v-text-field>
		<v-select v-model="item.shipping" :items="shippingItems" label="Spedizione" dense outlined hide-details @change="$emit('shipping', item)">
			<template slot="append-outer" v-if="operazione('shipping')">
				<v-icon color="primary" @click="$emit('save', item.operation)">mdi-content-save-outline</v-icon>
			</template>
		</v-select>
	</div>
</template>

<script>
export default {
	name: 'AmazonSellerFields',
	props: {
		// riga della tabella: i campi seller* vengono modificati sul posto, come prima
		item: { type: Object, required: true },
		currencies: { type: Array, default: () => [] },
		shippingItems: { type: Array, default: () => [] },
	},
	methods: {
		operazione(tipo) {
			return this.item.operation?.OperationType === tipo;
		},
	},
};
</script>

<style scoped>
.currency-select {
	max-width: 90px;
}
/* ::v-deep perche' la classe .v-input e' dentro i componenti Vuetify */
.seller-fields ::v-deep .v-input + .v-input,
.seller-fields ::v-deep .d-flex + .v-input {
	margin-top: 8px;
}
/* La valuta e' affiancata al prezzo: la regola sopra la spingerebbe in basso */
.seller-fields ::v-deep .d-flex > .v-input {
	margin-top: 0;
}
</style>
